export default __webpack_public_path__ + "static/media/stars.fd088f1d.png";